import React from "react";

function NoInternet() {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
            <div style={{ marginBottom: 24, position: 'relative' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="72" height="58" viewBox="0 0 72 58" fill="none">
                    {/* WiFi arcs */}
                    <path d="M36 18C43.2 18 49.8 20.7 54.6 25.2" stroke="#555" strokeWidth="3" strokeLinecap="round" />
                    <path d="M17.4 25.2C22.2 20.7 28.8 18 36 18" stroke="#555" strokeWidth="3" strokeLinecap="round" />
                    <path d="M36 28C40.8 28 45.2 29.8 48.4 32.8" stroke="#555" strokeWidth="3" strokeLinecap="round" />
                    <path d="M23.6 32.8C26.8 29.8 31.2 28 36 28" stroke="#555" strokeWidth="3" strokeLinecap="round" />
                    <path d="M36 38C38.4 38 40.6 38.9 42.2 40.4" stroke="#555" strokeWidth="3" strokeLinecap="round" />
                    <path d="M29.8 40.4C31.4 38.9 33.6 38 36 38" stroke="#555" strokeWidth="3" strokeLinecap="round" />
                    {/* Diagonal line (disconnected) */}
                    <line x1="52" y1="14" x2="20" y2="46" stroke="#555" strokeWidth="3" strokeLinecap="round" />
                </svg>
                {/* Small red warning triangle */}
                <div style={{ position: 'absolute', bottom: -4, right: -4 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M3.5 20.5h17L12 3.5 3.5 20.5z" fill="#dc3545" stroke="#dc3545" strokeWidth="1" strokeLinejoin="round" />
                        <text x="12" y="18" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">!</text>
                    </svg>
                </div>
            </div>
            <h1 style={{ fontSize: '20px', fontWeight: 600, color: '#111827', marginBottom: 8 }}>
                Ooops!....Your internet is not working
            </h1>
            <p style={{ fontSize: '14px', color: '#6c757d', marginBottom: 24 }}>
                Your internet is not working. Try reconnecting or switching to another network.
            </p>
            <button
                className="btn text-white"
                style={{ backgroundColor: '#3b5ca0', padding: '10px 32px', borderRadius: 6, fontSize: '15px' }}
                onClick={() => window.location.reload()}
            >
                Try Again
            </button>
        </div>
    );
}

export default NoInternet;